var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVoiceCall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 23.8 23.8",
    style: {
      enableBackground: "new 0 0 23.8 23.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.7,5.8c-0.3-3.4-3.8-5-4-5.1c0-0.1-0.2-0.1-0.4-0.1c-4.1,0.7-4.7,3-4.7,3.1s0,0.3,0,0.4 c4.8,15,14.9,17.8,18.2,18.7c0.3,0.1,0.5,0.1,0.6,0.2c0.2,0.1,0.4,0,0.6,0c0.1,0,2.5-1.2,3.1-4.8c0-0.2,0-0.3-0.1-0.5 c-0.1-0.1-1.3-2.5-4.8-3.3c-0.2-0.1-0.5,0-0.7,0.2c-1.1,0.9-2.6,1.9-3.3,2c-4.4-2.1-6.8-6.2-6.9-7c-0.1-0.4,0.9-2,2.1-3.2 C9.7,6.2,9.8,6,9.7,5.8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoiceCall);
export default __webpack_public_path__ + "static/media/voice-call.fee31a28eda0a642d5b26dd7a23032be.svg";
export { ForwardRef as ReactComponent };